// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"e9248cfa","180":"24322662","283":"e375045b","684":"1b884c27","718":"009de522"}[chunkId] + ".chunk.css";
};